/**
 * WebMCP — expose des actions du site aux agents (Chrome / spec WebMCP).
 * @see https://webmachinelearning.github.io/webmcp/
 * @see https://developer.chrome.com/blog/webmcp-epp
 */

const TOOLS = [
  {
    name: "raguia_navigate",
    description: "Navigue vers une page du site Raguia.",
    inputSchema: {
      type: "object",
      properties: {
        path: {
          type: "string",
          description: "Chemin absolu (ex. /tarifs, /contact, /fonctionnalites).",
        },
      },
      required: ["path"],
    },
    execute: async ({ path }) => {
      const p = path.startsWith("/") ? path : `/${path}`;
      window.location.assign(p);
      return { ok: true, path: p };
    },
  },
  {
    name: "raguia_page_context",
    description:
      "Retourne le titre, l'URL et le chemin de la page actuellement affichée.",
    inputSchema: {
      type: "object",
      properties: {},
    },
    execute: async () => ({
      href: window.location.href,
      pathname: window.location.pathname,
      title: document.title,
    }),
  },
  {
    name: "raguia_site_info",
    description:
      "Retourne les principales ressources machine de la plateforme Raguia (API, docs, santé).",
    inputSchema: {
      type: "object",
      properties: {},
    },
    execute: async () => ({
      apiCatalog: "/.well-known/api-catalog",
      openapi: "/openapi.json",
      agentSkills: "/.well-known/agent-skills/index.json",
      agentCard: "/.well-known/agent-card.json",
      mcpServerCard: "/.well-known/mcp/server-card.json",
      health: "/health",
    }),
  },
];

export function registerWebMcp({ signal } = {}) {
  const mc =
    typeof navigator !== "undefined" ? navigator.modelContext : null;
  if (!mc) return;

  const opts = signal ? { signal } : {};

  // Spec actuelle : registerTool() par outil
  if (typeof mc.registerTool === "function") {
    for (const tool of TOOLS) {
      mc.registerTool(tool, opts);
    }
    return;
  }

  // Ancien draft : provideContext({ tools })
  if (typeof mc.provideContext === "function") {
    mc.provideContext({ tools: TOOLS }, opts);
  }
}

